"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SprayMain = void 0;
const ltpoint_1 = require("../cadplugins/cad/ltpoint");
const closedAreaSearchV2_1 = require("./polygon/closedAreaSearchV2");
const geometryParser_1 = require("./geometryParser");
const ltvectorlayer_1 = require("../cadplugins/data/ltvectorlayer");
const pipeSizeTextDrawer_1 = require("./pipe/pipeSizeTextDrawer");
const LineSegment_js_1 = __importDefault(require("jsts/org/locationtech/jts/geom/LineSegment.js"));
const Coordinate_js_1 = __importDefault(require("jsts/org/locationtech/jts/geom/Coordinate.js"));
const ltentity_1 = require("../cadplugins/cad/ltentity");
const pipeSizeMap_1 = require("./sizeCompute/pipeSizeMap");
const ltfeature_1 = require("../cadplugins/data/ltfeature");
const ltfields_1 = require("../cadplugins/data/ltfields");
const sprinklerutils_1 = require("./sprinkler/sprinklerutils");
const pipeGeneratorV4_1 = require("./pipe/pipeGeneratorV4");
const pipeNode_1 = require("./pipe/pipeNode");
const waterTestingValveGeneratorV2_1 = require("./waterTestingValve/waterTestingValveGeneratorV2");
const dimensionCalculator_1 = require("./dimension/dimensionCalculator");
const dimensionDrawer_1 = require("./dimension/dimensionDrawer");
const polygonFilter_1 = require("./polygon/polygonFilter");
const adjustMainPipeV2_1 = require("./pipe/adjustMainPipeV2");
const polygonAdjust_1 = require("./polygon/polygonAdjust");
const Vector2D_js_1 = __importDefault(require("jsts/org/locationtech/jts/math/Vector2D.js"));
const pipeCommonUtil_1 = require("./pipe/util/pipeCommonUtil");
const sprayCheck_1 = require("./sprayCheck");
const mainPipeUnion_1 = require("./mainPipeUnion");
const drawUtil_1 = require("./pipe/util/draw/drawUtil");
class SprayMain {
    constructor(canvas, layers, cadMap) {
        this._canvas = canvas;
        this._layers = layers;
        this._cadMap = cadMap;
    }
    testDrawLine(mainPipeLayer, line) {
        let lineFeature = new ltfeature_1.LTFeature({
            geometry: line,
            layer: mainPipeLayer
        });
        lineFeature.setValue(ltfields_1.FieldNames.EntityLayer, lineFeature.layer.name);
        lineFeature.setValue(ltfields_1.FieldNames.Color, "ByLayer");
        lineFeature.setValue(ltfields_1.FieldNames.Linetype, "ByLayer");
        lineFeature.setValue(ltfields_1.FieldNames.Width, 0.0);
        lineFeature.setValue(ltfields_1.FieldNames.Rotate, 0.0);
        this._cadMap.addFeature(lineFeature);
    }
    execute(value) {
        let calculateLayers = value.selectLayers;
        let mainPipeFeatures = value.mainpipe; //主管道
        let selectedFeatures = value.select;
        let waterFlowFeatures = value.waterflow; //水流指示器
        let autoPipeFeatures = value.auto; //自喷管
        let drawscale = value.drawscale;
        let riserName = value.riserName;
        let mainPipeDistanceToWall = value.distanceToWall;
        let sprayRadius = value.sprayRadius * 1000;
        let relationshipArray = value.pipeSizeMap;
        let minDisToWall = value.projectAreaInfo.minDisWithWall * 1000;
        let minDisBetweenSprinklers = value.projectAreaInfo.minDisBetweenSprinklers * 1000;
        //是否不设置主干管到墙体的距离
        let notSetDistanceToWall = value.notSetDistanceToWall;
        //喷头设置方式
        let sprinklerSettingMethod = value.sprinklerBlockName;
        let calculateFeatures = new Array();
        for (let layer of this._layers) {
            if (calculateLayers.indexOf(layer.name) > -1) {
                let features = layer.getFeatures(null);
                //判断要素是否被选择
                for (let feature of features) {
                    if (selectedFeatures.indexOf(feature) > -1) {
                        calculateFeatures.push(feature);
                    }
                }
            }
        }
        let geometryParser = new geometryParser_1.GeometryParser();
        let closedAreaResult = new closedAreaSearchV2_1.ClosedAreaSearchV2().execute(calculateFeatures, geometryParser);
        let polygons = closedAreaResult._polygons;
        //通过多边形内缩的方式排除掉墙
        //TODO：里面还包含了过滤多边形的方法，后续需要改一下类名
        let polygonFilter = new polygonFilter_1.PolygonFilter();
        polygonFilter.eliminate(polygons);
        polygonFilter.removePolygonWhichWholeInOtherHole(polygons);
        //多边形调整
        let polygonAdjust = new polygonAdjust_1.PolygonAdjust();
        polygons = polygonAdjust.adjust(polygons, geometryParser);
        let b_generatePipe = true;
        if (b_generatePipe) {
            let mainPipeLayer = null;
            let childPipeLayer = null;
            //喷头图层;
            let pipeDozzleLayer = null;
            let pipeDiameterLayer = null;
            let dimensionLayer = null;
            for (let layer of this._layers) {
                if (mainPipeLayer && childPipeLayer && pipeDiameterLayer && pipeDozzleLayer) {
                    break;
                }
                if (!mainPipeLayer && layer.name === sprinklerutils_1.MAINPIPE_LAYER) {
                    mainPipeLayer = layer;
                }
                else if (!childPipeLayer && layer.name == sprinklerutils_1.BRANCHPIPE_LAYER) {
                    childPipeLayer = layer;
                }
                else if (!pipeDiameterLayer && layer.name == sprinklerutils_1.PIPDIAMETER_ANNO_LAYER) {
                    pipeDiameterLayer = layer;
                }
                else if (!dimensionLayer && layer.name == sprinklerutils_1.SPRINKLER_LOCATION_LAYER) {
                    dimensionLayer = layer;
                }
                else if (!pipeDozzleLayer && layer.name == sprinklerutils_1.SPRINKLER_NOZZLE_LAYER) {
                    pipeDozzleLayer = layer;
                }
            }
            if (mainPipeLayer == null) {
                //添加缺少的图层;
                mainPipeLayer = new ltvectorlayer_1.LTVectorlayer(sprinklerutils_1.MAINPIPE_LAYER);
                this._cadMap.addLayer(mainPipeLayer);
            }
            if (childPipeLayer == null) {
                childPipeLayer = new ltvectorlayer_1.LTVectorlayer(sprinklerutils_1.BRANCHPIPE_LAYER);
                this._cadMap.addLayer(childPipeLayer);
            }
            if (pipeDiameterLayer == null) {
                pipeDiameterLayer = new ltvectorlayer_1.LTVectorlayer(sprinklerutils_1.PIPDIAMETER_ANNO_LAYER);
                this._cadMap.addLayer(pipeDiameterLayer);
            }
            if (dimensionLayer == null) {
                dimensionLayer = new ltvectorlayer_1.LTVectorlayer(sprinklerutils_1.SPRINKLER_LOCATION_LAYER);
                this._cadMap.addLayer(dimensionLayer);
            }
            if (pipeDozzleLayer == null) {
                pipeDozzleLayer = new ltvectorlayer_1.LTVectorlayer(sprinklerutils_1.SPRINKLER_NOZZLE_LAYER);
                this._cadMap.addLayer(pipeDozzleLayer);
            }
            /*for (let line of closedAreaResult._lines) {
                this.testDrawLine(mainPipeLayer!, new LTLine(line[0], line[1]));
            }
            return;*/
            /*for (let line of geometryParser.getDoorLineSegments().concat(geometryParser.getColumnLineSegments())) {
                this.testDrawLine(mainPipeLayer!, new LTLine(new LTPoint(line.p0.x, line.p0.y), new LTPoint(line.p1.x, line.p1.y)));
            }
            return;*/
            /*for (let polygon of polygons) {
                const shell = polygon.getExteriorRing();
                let points_shell = shell.getCoordinates();
                for (let i = 0; i < points_shell.length - 1; i++) {
                    this.testDrawLine(mainPipeLayer!, new LTLine(new LTPoint(points_shell[i].x, points_shell[i].y), new LTPoint(points_shell[i + 1].x, points_shell[i + 1].y)));
                }
                for (let i = 0; i < polygon.getNumInteriorRing(); i++) {
                    const hole = polygon.getInteriorRingN(i);
                    let points_hole = hole.getCoordinates();
                    for (let i = 0; i < points_hole.length - 1; i++) {
                        this.testDrawLine(mainPipeLayer!, new LTLine(new LTPoint(points_hole[i].x, points_hole[i].y), new LTPoint(points_hole[i + 1].x, points_hole[i + 1].y)));
                    }
                }
            }
            return;*/
            /*let startPoint = new Coordinate(4923978.347, -1087094.453);
            let polylines = new Array<LTPolyline>();
            polylines.push(new LTPolyline(
                [
                    new LTPoint(4923978.347, -1087094.453),
                    new LTPoint(4923933.808, -1087522.537),
                    new LTPoint(4912626.979, -1086429.302),
                    new LTPoint(4912595.934, -1086211.829),
                    new LTPoint(4909413.114, -1085880.683),
                    new LTPoint(4909319.979, -1086775.851),
                    new LTPoint(4892847.370, -1085062.015),
                    new LTPoint(4885025.335, -1115948.461),
                    new LTPoint(4875525.251, -1113542.551),
                    new LTPoint(4873021.140, -1123430.394),
                ]));
            polylines.push(new LTPolyline(
                [
                    new LTPoint(4912626.979, -1086429.302),
                    new LTPoint(4912608.703, -1085911.538),
                    new LTPoint(4913411.131, -1077433.791),
                    new LTPoint(4926478.091, -1078884.304),
                ]));*/
            /*let startPoint = new Coordinate(4926682.049, -1084948.997);
            let polylines = new Array<LTPolyline>();
            polylines.push(new LTPolyline(
                [
                    new LTPoint(4926682.049, -1084948.997),
                    new LTPoint(4927289.525, -1078652.463),
                    new LTPoint(4913312.967, -1077276.216),
                    new LTPoint(4912273.135, -1088030.061),
                    new LTPoint(4893248.187, -1086167.587),
                    new LTPoint(4882478.520, -1129191.187),
                    new LTPoint(4872267.821, -1126801.116),
                    new LTPoint(4875618.562, -1113184.620),
                ]));*/
            //取水流指示器的右边点，作为起始点
            let waterFlowPointPair = geometryParser.getWaterFlowIndicatorRightMostPoint(waterFlowFeatures[0].getGeometry(), this._canvas.getBlocks());
            let startPoint = new Coordinate_js_1.default(waterFlowPointPair[1].x, waterFlowPointPair[1].y);
            let polylines = new Array();
            for (let feature of mainPipeFeatures) {
                let geometry = feature.getGeometry();
                if (geometry instanceof ltentity_1.LTPolyline === false) {
                    console.error("主管线类型错误");
                    continue;
                }
                let polyline = geometry;
                polylines.push(polyline);
            }
            //以与水流指示器相连的那个多段线作为主要的多段线
            let lineStringArr = mainPipeUnion_1.MainPipeUnion.Union(polylines);
            let mainLineString = lineStringArr[0];
            for (let i = 1; i < lineStringArr.length; i++) {
                let lineString = lineStringArr[i];
                let sp = lineString.getStartPoint();
                let ep = lineString.getEndPoint();
                if (startPoint.equals2D(sp, 1e-3) || startPoint.equals2D(ep, 1e-3)) {
                    mainLineString = lineString;
                }
            }
            //把这个closedAreaResult._lines数组内的圆弧线段（可以通过长度过滤）过滤掉，避免圆弧导致出现主管线歪了的情况
            let lines = closedAreaResult._lines.concat(); //这些lines都只有两个点
            for (let i = lines.length - 1; i >= 0; i--) {
                let length = lines[i][0].getDistanceTo(lines[i][1]);
                if (length < 100)
                    lines.splice(i, 1);
            }
            //把门的线段也过滤掉
            const adjustTolerance = 110; //为了有效过滤，这个值的设定比门线段调整的阈值100大一点点
            for (let i = lines.length - 1; i >= 0; i--) {
                let p0 = lines[i][0];
                let p1 = lines[i][1];
                for (let door of geometryParser.getDoorLineSegments()) {
                    let p2 = new ltpoint_1.LTPoint(door.p0.x, door.p0.y);
                    let p3 = new ltpoint_1.LTPoint(door.p1.x, door.p1.y);
                    let d0 = p0.getDistanceTo(p2);
                    let d1 = p1.getDistanceTo(p3);
                    if (d0 < adjustTolerance && d1 < adjustTolerance) {
                        lines.splice(i, 1);
                        break;
                    }
                    let d2 = p0.getDistanceTo(p3);
                    let d3 = p1.getDistanceTo(p2);
                    if (d2 < adjustTolerance && d3 < adjustTolerance) {
                        lines.splice(i, 1);
                        break;
                    }
                }
            }
            //把柱子的线段也过滤了
            for (let i = lines.length - 1; i >= 0; i--) {
                let p0 = lines[i][0];
                let p1 = lines[i][1];
                for (let door of geometryParser.getColumnLineSegments()) {
                    let p2 = new ltpoint_1.LTPoint(door.p0.x, door.p0.y);
                    let p3 = new ltpoint_1.LTPoint(door.p1.x, door.p1.y);
                    if (p0.equalsFuzzy(p2, 1) && p1.equalsFuzzy(p3, 1)) {
                        lines.splice(i, 1);
                        break;
                    }
                    else if (p0.equalsFuzzy(p3, 1) && p1.equalsFuzzy(p2, 1)) {
                        lines.splice(i, 1);
                        break;
                    }
                }
            }
            /*for (let line of lines) {
                this.testDrawLine(mainPipeLayer!, new LTLine(line[0], line[1]));
            }
            return;*/
            //调整主管线到墙壁附近
            let adJustMainPipeV2 = new adjustMainPipeV2_1.AdjustMainPipeV2();
            let rootAdjustMainPipe = adJustMainPipeV2.adjust(mainLineString, lineStringArr, lines, mainPipeDistanceToWall, notSetDistanceToWall);
            //将调整后的第一段线需要重新连接上水流指示器
            if (!rootAdjustMainPipe._selfSeg.p0.equals2D(startPoint)) {
                let originRootNode = new pipeNode_1.PipeNode(startPoint, pipeNode_1.PipeNodeType.Main);
                let firstMainNode = rootAdjustMainPipe._pipeNodes[0];
                //以originRootNode对第一段线作垂线，然后通过垂点相连，避免出现斜连线
                let firstPipe = new LineSegment_js_1.default(firstMainNode._point, firstMainNode._children[0]._point);
                let projectionFactor = firstPipe.projectionFactor(originRootNode._point);
                let projectionPoint = firstPipe.pointAlong(projectionFactor);
                if (projectionFactor < -1e-4) { //如果垂点在线段外，则直接连接三个点
                    let linkNode = new pipeNode_1.PipeNode(projectionPoint, pipeNode_1.PipeNodeType.Main);
                    originRootNode.addChildNode(linkNode);
                    linkNode.addChildNode(firstMainNode);
                    rootAdjustMainPipe._pipeNodes.splice(0, 0, linkNode);
                }
                else { //如果垂点在线段内，则将线段的p0移动到垂点位置，连接两个点
                    firstMainNode._point.x = projectionPoint.x;
                    firstMainNode._point.y = projectionPoint.y;
                    originRootNode.addChildNode(firstMainNode);
                }
                rootAdjustMainPipe._pipeNodes.splice(0, 0, originRootNode);
            }
            let mainPipes = new Array();
            pipeCommonUtil_1.PipeCommonUtil.traverseToGetMainPipes(rootAdjustMainPipe._pipeNodes[0], mainPipes);
            let mainPipeNodes = new Array();
            pipeCommonUtil_1.PipeCommonUtil.traverseToGetMainPipeNodes(rootAdjustMainPipe._pipeNodes[0], mainPipeNodes);
            let pipeGenerator = new pipeGeneratorV4_1.PipeGeneratorV4(sprayRadius, minDisToWall, minDisBetweenSprinklers);
            //经过这个方法之后mainPipes和mainPipeNodes已经被修改
            let pipeResults = pipeGenerator.generate(polygons, mainPipes, mainPipeNodes, geometryParser);
            //移除原有的主管线
            this._cadMap.removeFeatures(mainPipeFeatures);
            let rootNode = mainPipeNodes[0];
            //处理连接到rootNode的某段主管线与水流指示器重叠的情况
            this.handleLineCoveredOnWaterFlow(waterFlowPointPair, rootNode);
            rootNode._depth = 0;
            rootNode.traverseToSetDepth();
            rootNode._distanceToRoot = 0;
            rootNode.traverseToSetDistanceToRoot();
            //试水阀计算
            new waterTestingValveGeneratorV2_1.WaterTestingValveGeneratorV2().generateOnlyOnDeepestNode(rootNode, pipeResults);
            //绘制房间标注
            let dimensionDrawer = new dimensionDrawer_1.DimensionDrawer(dimensionLayer, this._cadMap);
            for (let pipeResult of pipeResults) {
                let dimensionArr = new dimensionCalculator_1.DimensionCalculator(drawscale).compute(pipeResult._pipeNodeGroups, pipeResult._polygonSegsLocal, pipeResult._doors, pipeResult._coordinateUtil);
                for (let dimension of dimensionArr) {
                    dimensionDrawer.draw(dimension, drawscale);
                }
            }
            //移除没有子节点的主管道节点，目的是为了截掉多余的主管道
            this.traverseToRemoveMainPipeNodeWithoutChild(rootNode);
            //合并距离过近的点
            this.traverseToMergeNearNodes(rootNode);
            //化简管线
            this.traverseToSimplifyLine(rootNode);
            //调整距离管喷头过近的主管线（这一调整方法目前来看十分不完善，暂时先注释）
            //let waterFlowCenter = waterFlowFeatures[0].getGeometry().getBoundingBox().getCenter();
            //new MainPipePostAdjust().adjustBySameLineGroup(rootNode, new Coordinate(waterFlowCenter.x, waterFlowCenter.y));
            let pipeSizeMap = new pipeSizeMap_1.PipeSizeMap(relationshipArray);
            let drawInfo = drawUtil_1.DrawUtil.GetDrawInfo(rootNode, mainPipeLayer, childPipeLayer, pipeDozzleLayer, pipeDiameterLayer, pipeSizeMap, sprinklerSettingMethod, drawscale, riserName, this._cadMap);
            drawInfo.addFeaturesToCadMap(this._cadMap);
            //绘制自喷管的管径
            this.drawPipeSizeTextForAutoPipe(autoPipeFeatures, rootNode, pipeSizeMap, pipeDiameterLayer, drawscale);
            //统计一下喷头数量，太少的话就报错
            new sprayCheck_1.SprayCheck().check(rootNode, this._cadMap);
            return;
        }
    }
    traverseToRemoveMainPipeNodeWithoutChild(node) {
        if (node._type != pipeNode_1.PipeNodeType.Main) {
            return;
        }
        for (let i = node._children.length - 1; i >= 0; i--) {
            let child = node._children[i];
            if (child._type == pipeNode_1.PipeNodeType.Main && child._children.length == 0) {
                node._children.splice(i, 1);
            }
            else {
                this.traverseToRemoveMainPipeNodeWithoutChild(child);
            }
        }
    }
    //自喷管绘制管径标注
    drawPipeSizeTextForAutoPipe(autoPipeFeatures, rootNode, pipeSizeMap, pipeDiameterTextLayer, drawscale) {
        let pipeCount = rootNode.computeChildrenNodes();
        let text = pipeSizeMap.getPipeSizeStr(pipeCount);
        for (let feature of autoPipeFeatures) {
            //将管径信息补充到自喷管线要素的属性中
            feature._xdata.pipeSize = text;
            let geometry = feature.getGeometry();
            if (geometry instanceof ltentity_1.LTPolyline === false) {
                console.error("自喷管类型错误");
                continue;
            }
            let polyline = geometry;
            let points = polyline.getPoints();
            for (let i = 0; i < points.length - 1; i++) {
                let ltText = pipeSizeTextDrawer_1.PipeSizeTextDrawer.getLTText(points[i], points[i + 1], text, drawscale);
                //构建管径文字要素
                let textFeature = new ltfeature_1.LTFeature({
                    geometry: ltText,
                    layer: pipeDiameterTextLayer,
                    xdata: JSON.stringify({
                        source: "autoGenerate",
                    }),
                });
                textFeature.setValue(ltfields_1.FieldNames.EntityLayer, textFeature.layer.name);
                textFeature.setValue(ltfields_1.FieldNames.EntityType, "AcDbText");
                textFeature.setValue(ltfields_1.FieldNames.Linetype, ltentity_1.dwg_bylayer);
                this._cadMap.addFeature(textFeature);
            }
        }
    }
    traverseToSimplifyLine(node) {
        let children = node._children.concat(); //复制一份，避免被修改后无法正常迭代
        if (node._type != pipeNode_1.PipeNodeType.Child && children.length == 1) {
            let child = children[0];
            let parent = node._parent;
            if (parent) {
                //三点共线则化简
                let vec1 = new Vector2D_js_1.default(node._point, parent._point);
                let vec2 = new Vector2D_js_1.default(node._point, child._point);
                let angle = vec1.angleTo(vec2);
                const tolerance = 175 / 180 * Math.PI;
                if (angle <= -1 * tolerance || angle >= tolerance) {
                    parent.removeChildNode(node);
                    node.removeChildNode(child);
                    parent.addChildNode(child);
                }
            }
        }
        for (let child of children) {
            this.traverseToSimplifyLine(child);
        }
    }
    traverseToMergeNearNodes(node) {
        for (let i = 0; i < node._children.length; i++) {
            let child = node._children[i];
            if (child._type == pipeNode_1.PipeNodeType.Child)
                continue;
            if (node._point.equals2D(child._point, 1)) {
                node.removeChildNode(child);
                for (let grandChild of child._children) {
                    node.addChildNode(grandChild);
                }
                i--;
            }
        }
        for (let child of node._children) {
            this.traverseToMergeNearNodes(child);
        }
    }
    handleLineCoveredOnWaterFlow(waterFlowPointPair, rootNode) {
        let minX_point = new Coordinate_js_1.default(waterFlowPointPair[0].x, waterFlowPointPair[0].y);
        let maxX_point = new Coordinate_js_1.default(waterFlowPointPair[1].x, waterFlowPointPair[1].y);
        let waterFlowSegment = new LineSegment_js_1.default(minX_point, maxX_point);
        for (let i = rootNode._children.length - 1; i >= 0; i--) {
            let child = rootNode._children[i];
            //判断是否与水流指示器重叠
            if (waterFlowSegment.distance(child._point) < 1) {
                //直接将其上移200，中间增加一段线
                rootNode._children.splice(i, 1);
                child._point.y += 200;
                let newChild = new pipeNode_1.PipeNode(new Coordinate_js_1.default(rootNode._point.x, child._point.y), pipeNode_1.PipeNodeType.Main);
                rootNode._children.push(newChild);
                newChild._children.push(child);
            }
        }
    }
}
exports.SprayMain = SprayMain;
